import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AlTarifsModule } from './app/app.module.al-tarifs';
const platform = platformBrowserDynamic();
platform.bootstrapModule(AlTarifsModule);